import {TrendingLandsMarketItems} from '#/components/market-data/trending-lands-market-items';
import {TrendingMarketItemButton} from '#/components/market-data/trending-market-item-button';
import {SyntheticMarketDataRange} from '#/types/synthetic-market-data-range';
import {FunctionComponent} from 'react';

export const TrendingMarketData: FunctionComponent = () => {
  const range: SyntheticMarketDataRange = 'monthly';

  return (
    <section
      className={
        'select-none @container/marketDataSection group/trending-market-data-section py-5 bg-[#e5e7eb57] overflow-hidden'
      }
    >
      <TrendingLandsMarketItems
        ItemComponent={TrendingMarketItemButton}
        itemComponentProps={{
          thumbnailMode: 'empty',
          range,
        }}
      />
    </section>
  );
};
